/**
 * Map the density slider (1..100) to a maxNoteCount for the phrase flow.
 * Scaling through beatsPerBar keeps density comparable across meters
 * (50 in 4/4 is about 8 notes, in 3/4 about 6); the floor keeps every
 * phrase sounding at least the downbeat note. Four notes per beat at
 * density 100 is the practical ceiling.
 */
function densityToMaxNoteCount(density: number, beatsPerBar: number): number {
    return Math.max(1, Math.round(density / 100 * beatsPerBar * 4));
}

export {densityToMaxNoteCount};
